import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import OptionValue from "@mapmycustomers/shared/types/customField/OptionValue";
import PinLegend, {
  ColorItemType,
  ShapeItemType,
  SimpleClassificationColorItem,
  SimpleClassificationShapeItem,
} from "@mapmycustomers/shared/types/map/PinLegend";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { isCustomField } from "@app/util/fieldModel/impl/assert";

const getSortedPinLegendItems = <T extends ColorItemType | ShapeItemType>(
  items?: T[],
  entityType?: PinLegend["entity"],
  fieldName?: PinLegend["fieldName"],
  customFieldEsKey?: CustomField["esKey"]
): T[] => {
  let sortedItems = items ?? [];

  const fieldModel = entityType && getFieldModelByEntityType(entityType);
  const finalFieldName = customFieldEsKey ? customFieldEsKey : fieldName;

  const field = finalFieldName && fieldModel?.getByName(finalFieldName);
  if (field && isCustomField(field) && field.isOptionField) {
    const optionsOrderMap = field.customFieldData.options.reduce(
      (result, { displayOrder, value }) => {
        result[value] = displayOrder;
        return result;
      },
      {} as Record<OptionValue["value"], OptionValue["displayOrder"]>
    );
    sortedItems = sortedItems.sort(
      (a, b) =>
        optionsOrderMap[
          (a as SimpleClassificationColorItem | SimpleClassificationShapeItem)
            .fieldValue as OptionValue["value"]
        ] -
        optionsOrderMap[
          (b as SimpleClassificationColorItem | SimpleClassificationShapeItem)
            .fieldValue as OptionValue["value"]
        ]
    );
  }

  return sortedItems;
};

export default getSortedPinLegendItems;
